<script>
import {BCard, BCardTitle, BFormGroup} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
    components: {
        BCard, BCardTitle, BFormGroup, vSelect
    },
    props: {
        statements: {
            type: Array,
            default: () => []
        },
        selectedIds: {
            type: Array,
            default: () => []
        }
    },
    methods: {}
}
</script>

<template>
    <b-card no-body>
        <div class="card-header">
            <div class="col-md-12 pl-0">
                <b-card-title>
                    General Product Statements
                </b-card-title>
            </div>
        </div>
        <div class="p-2">
            <b-form-group>
                <v-select
                    :value="selectedIds"
                    :options="statements"
                    multiple
                    label="title"
                    :reduce="statement => statement.id"
                    :close-on-select="false"
                    @input="$emit('input', $event)"
                />
            </b-form-group>
        </div>
    </b-card>
</template>
